export const HOME = '/'

export const AUTH = '/auth'
export const LOGIN = AUTH + '/login'
export const PORTAL_LOGIN = AUTH + '/portal-login'

export const COMPANY_LIST = '/company-list'
export const DASHBOARD = '/dashboard'
export const HELP = '/help'

// master data
export const MASTERDATA = '/masterdata'
export const CATEGORY_LIST = MASTERDATA + '/category'
export const BRAND_LIST = MASTERDATA + '/brand'
export const MODEL_LIST = MASTERDATA + '/model'
export const VENDOR_LIST = MASTERDATA + '/vendor'
export const DEPARTMENT_LIST = MASTERDATA + '/department'
export const DESIGNATION_LIST = MASTERDATA + '/designation'
export const LOCATION_LIST = MASTERDATA + '/location'
export const EMPLOYEE_LIST = MASTERDATA + '/employee'

// asset
export const ASSET_LIST = '/asset'
export const ASSET_DETAIL: (p: {id: string}) => string = ({id}) => `${ASSET_LIST}/${id}`
export const WARRANTY_EXPIRY_LIST = '/warranty-expiry'

// procurement
export const PURCHASE_ORDER_LIST = '/purchase-order'
export const PURCHASE_ORDER_DETAIL: (p: {id: string}) => string = ({id}) => `${PURCHASE_ORDER_LIST}/${id}`

// software license
export const SOFTWARE_LICENSE_LIST = '/software-license'
export const SOFTWARE_LICENSE_DETAIL: (p: {id: string}) => string = ({id}) => `${SOFTWARE_LICENSE_LIST}/${id}`
export const LICENSE_EXPIRY_LIST = '/license-expiry'

// inventory
export const INVENTORY_ITEM_LIST = '/inventory-item'
export const INVENTORY_ITEM_DETAIL: (p: {id: string}) => string = ({id}) => `${INVENTORY_ITEM_LIST}/${id}`
export const LOW_STOCK_LIST = '/low-stock'

// notifications
export const NOTIFICATION_LIST = '/notification'

// reports
export const REPORTS = '/report'
export const ASSET_REGISTER_REPORT = '/report/asset-register'
export const ASSIGNMENT_HISTORY_REPORT = '/report/assignment-history'
export const REPAIR_HISTORY_REPORT = '/report/repair-history'
export const DEPARTMENT_WISE_REPORT = '/report/department-wise'
export const LOCATION_WISE_REPORT = '/report/location-wise'
export const COST_SUMMARY_REPORT = '/report/cost-summary'
